module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAnklEQVQ4jWO8duchMwMDA0P9j1VvGRgY+BnIAx8bOcKEGRgYGJiQBMk1DEUvC7pMI0cYhhg+UP9j1R9kPhMuheSCUQNHDRw1cEAMxCgI0DM7NyO7ahm7/30GBgaGmb928zz79/4VAwMDG9EGooNv/3/O7fq5MYWVgeXzx/9fp+IzjCgD/zMw2H39//MWA8NPQkoZGBhoHCkfKTAHrhcASJYpf0smTEAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/tel/device.png
// module id = BvlB
// module chunks = 4